import { render, staticRenderFns } from "./JobPreviewContentBarData.vue?vue&type=template&id=5bd88de7&scoped=true"
import script from "./JobPreviewContentBarData.vue?vue&type=script&lang=js"
export * from "./JobPreviewContentBarData.vue?vue&type=script&lang=js"
import style0 from "./JobPreviewContentBarData.vue?vue&type=style&index=0&id=5bd88de7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd88de7",
  null
  
)

export default component.exports